import { method } from "@/common/common.js"
import { compositeType } from "@/common/commonData.js"
import { getRecommend, searchPage, getStatistics, } from "@/api/basicApi.js"

import LoadingView from "@/components/LoadingView/LoadingView.vue"

export default {
    props: {
        windowWidth: {
            type: Number,
            default: 0,
        },
    },
    components: {
        LoadingView,
    },
    data() {
        return {
            method,
            searchText: '',
            focusFlag: false,
            searchBottomWidth: 0,
            searchRecommendSize: 0,
            searchRecordList: [],// 搜索历史
            searchRecommendList: [],// 搜索推荐
            searchList: [],
            showWindow: false,
            showContent: false,
            showRecommendList: false,
            antiShake: null,
            total: 0,
            loading: false,
            statisticsData: {
                totalData: 0,
                monthData: 0,
            }
        }
    },
    methods: {
        init() {
            getRecommend({
                status: 3,
            }).then(res => {
                if (res.code == "0000") {
                    for (let i = 0; i < res.data.length; i++) {
                        for (let j = 0; j < compositeType.length; j++) {
                            if (res.data[i].sourceCode == compositeType[j].value) {
                                res.data[i].typeText = compositeType[j].label;
                                res.data[i].typeColor = compositeType[j].color;
                                res.data[i].gradientColor = compositeType[j].gradientColor;
                            }
                            if (res.data[i].sourceCode == "charhoo_article") {
                                res.data[i].path = '/article-read';
                                res.data[i].query = {
                                    id: res.data[i].sourceId
                                };
                            } else if (res.data[i].sourceCode == "charhoo_talk_article") {
                                res.data[i].path = '/talk-read';
                                res.data[i].query = {
                                    id: res.data[i].sourceId
                                };
                            } else if (res.data[i].sourceCode == "charhoo_picture") {
                                res.data[i].path = '/picture-read';
                                res.data[i].query = {
                                    id: res.data[i].sourceId
                                };
                            }
                        }
                    }
                    this.searchRecommendList = res.data;
                }
            })
        },
        getStatisticsData() {
            getStatistics().then(res => {
                if(res.code == "0000") {
                    this.statisticsData = res.data;
                }
            })
        },
        openWindow() {
            this.getSearchHistory();
            this.showWindow = true;
            document.querySelector("body").style.overflow = "hidden";
            if (this.windowWidth > 800) {
                document.querySelector("body").style.paddingRight = "10px";
            }
            setTimeout(() => {
                this.showContent = true;

                setTimeout(() => {
                    this.showRecommendList = true;
                    this.handleSearchWindowResize();
                }, 300);
            }, 200);
        },
        closeWindow() {
            this.showContent = false;
            this.closeTimeout = setTimeout(() => {
                if (this.showWindow == true) {
                    document.querySelector("body").style.overflow = "";
                    document.querySelector("body").style.paddingRight = "";
                }
                this.showWindow = false;
                this.showRecommendList = false;
            }, 300);
        },
        nullFn() {

        },
        cleanText() {
            this.searchText = '';
        },
        // 搜索框获取焦点
        search_focus() {
            this.focusFlag = true;
        },
        // 搜索框失去焦点
        search_blur() {
            this.focusFlag = false;
        },
        searchInfo() {
            if (!method.isNull(this.searchText)) {
                if (window.innerWidth > 800) {
                    let routeData = this.$router.resolve({
                        path: '/search', query: { keyword: this.searchText, page_num: 1, code: "all" }
                    });
                    window.open(routeData.href, '_blank');
                } else {
                    this.$router.push({
                        path: '/search', query: { keyword: this.searchText, page_num: 1, code: "all" }
                    });
                }
            } else {
                method.Message_warning("请输入要搜索的内容！")
            }
        },
        searchData() {
            this.loading = true;
            searchPage({
                name: this.searchText,
                page_num: 1,
                page_size: 10,
                desc: 1,
            }).then(res => {
                for (let i = 0; i < res.data.list.length; i++) {
                    for (let j = 0; j < compositeType.length; j++) {
                        if (res.data.list[i].sourceCode == compositeType[j].value) {
                            res.data.list[i].typeText = compositeType[j].label;
                            res.data.list[i].typeColor = compositeType[j].color;
                            res.data.list[i].gradientColor = compositeType[j].gradientColor;
                        }
                        if (res.data.list[i].sourceCode == "charhoo_article") {
                            res.data.list[i].path = '/article-read';
                            res.data.list[i].query = {
                                id: res.data.list[i].sourceId
                            };
                        } else if (res.data.list[i].sourceCode == "charhoo_talk_article") {
                            res.data.list[i].path = '/talk-read';
                            res.data.list[i].query = {
                                id: res.data.list[i].sourceId
                            };
                        } else if (res.data.list[i].sourceCode == "charhoo_picture") {
                            res.data.list[i].path = '/picture-read';
                            res.data.list[i].query = {
                                id: res.data.list[i].sourceId
                            };
                        }
                    }
                }
                this.searchList = res.data.list;
                this.total = res.data.total;

                if (!method.isNull(this.searchList)) {
                    method.setSearchHistory(this.searchText);
                    this.getSearchHistory();
                }

                setTimeout(() => {
                    this.loading = false;
                }, 100);
            })
        },
        handleSearchWindowResize() {
            if (this.$refs.searchBottom) {
                this.searchBottomWidth = this.$refs.searchBottom.offsetWidth;
            }
            if (this.$refs.searchRecommendList) {
                let height = this.$refs.searchRecommendList.offsetHeight;
                this.searchRecommendSize = Math.floor(height / 55);
            }

        },
        // 获取搜索历史
        getSearchHistory() {
            this.searchRecordList = method.getSearchHistory();
        },
        // 点击搜索历史
        clickHistory(data) {
            if (window.innerWidth > 800) {
                let routeData = this.$router.resolve({
                    path: '/search', query: { keyword: data, page_num: 1, code: "all" }
                });
                window.open(routeData.href, '_blank');
            } else {
                this.$router.push({
                    path: '/search', query: { keyword: data, page_num: 1, code: "all" }
                });
            }
        },
        // 删除搜索历史
        delSearchHistory(text) {
            method.delSearchHistory(text);
            this.getSearchHistory();
        },
        // 清空搜索历史
        clearSearchHistory() {
            this.$confirm('是否清空搜索历史？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                center: true,
            }).then(() => {
                method.clearSearchHistory();
                this.getSearchHistory();
            }).catch(() => {
            });
        },
        closeWindowFn() {
            if (this.$route.query.search == 'true') {
                if (window.history.length > 1) {
                    this.$router.go(-1);
                } else {
                    this.$router.replace("/");
                }
            }
        }
    },
    watch: {
        searchText() {
            clearTimeout(this.antiShake);
            this.antiShake = null;
            this.antiShake = setTimeout(() => {
                this.searchData()
            }, 500);
        },
        $route() {
            if (this.$route.query.search == 'true') {
                this.openWindow();
            } else {
                this.closeWindow();
            }
        },
    },
    mounted() {
        this.init();
        this.getStatisticsData();
        this.getSearchHistory();
        this.handleSearchWindowResize();
        window.addEventListener('resize', this.handleSearchWindowResize);
        setTimeout(() => {
            if (this.$route.query.search == 'true') {
                this.openWindow();
            } else {
                this.closeWindow();
            }
        }, 100);

    },
    beforeDestroy() {
        clearTimeout(this.antiShake);
        this.antiShake = null;
        window.removeEventListener('resize', this.handleSearchWindowResize);
    }
}